import {StyledIconContainer, Icon, StyledTypography} from "./StyledComponents";
import ReactHtmlParser from "@mediaspace/shared/ui/html-react-parser";
import {Truncate} from "@mediaspace/shared/ui";
import {Tooltip} from "@kaltura/ds-react-components";
import {ButtonClickAnalyticsType} from "@mediaspace/shared/types/ButtonClickAnalyticsType";
import {useButtonAnalytics} from "@mediaspace/hooks";

export interface Channel {
    name: string;
    url: string;
    iconUrl: string;
    createdAt: number;
    membersCount: number;
    entriesCount: number;
    updatedAt: number;
    order?: number;
}

export interface ChannelIconProps {
    channel: Channel;
    itemsInLine: number;
    disableEntitlements: boolean;
}

const ChannelIcon = (props: ChannelIconProps) => {

    const {channel, itemsInLine, disableEntitlements} = props;
    const {iconUrl, url, name} = channel;

    const sendButtonAnalytics = useButtonAnalytics();

    return (
        <StyledIconContainer
            href={url}
            disableEntitlements={disableEntitlements}
            itemsInLine={itemsInLine}
            onClick={() => sendButtonAnalytics("Channels collection component - channel thumbnail", ButtonClickAnalyticsType.THUMBNAIL)}
        >
            <Icon
                style={{backgroundImage: `url(${iconUrl})`}}
                itemsInLine={itemsInLine}
            />
            <Tooltip
                title={name}
                placement={"top"}
            >
                <StyledTypography variant={"body1"}>
                    <Truncate
                        lines={2}
                        showMore={false}
                    >
                        {ReactHtmlParser(name)}
                    </Truncate>
                </StyledTypography>
            </Tooltip>
        </StyledIconContainer>
    )
}

export default ChannelIcon;
